'use client'

import { useState, type ReactNode } from 'react'

type CollapsibleCategoryBlockProps = {
  categoryName: string
  itemCount: number
  defaultOpen?: boolean
  children: ReactNode
  summary?: ReactNode
}

export function CollapsibleCategoryBlock({
  categoryName,
  itemCount,
  defaultOpen = false,
  children,
  summary,
}: CollapsibleCategoryBlockProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border border-outline-variant rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 bg-surface-container text-left min-h-[44px]"
        aria-expanded={open}
      >
        <div className="flex items-center gap-2 min-w-0">
          <span className="material-symbols-outlined text-lg text-on-surface-variant shrink-0">
            {open ? 'expand_less' : 'expand_more'}
          </span>
          <span className="text-body-sm font-semibold text-on-surface truncate">{categoryName}</span>
          <span className="text-label-md text-on-surface-variant shrink-0">{itemCount} produk</span>
        </div>
        {summary ? <div className="text-label-md text-on-surface-variant shrink-0">{summary}</div> : null}
      </button>
      {open ? <div className="border-t border-outline-variant">{children}</div> : null}
    </div>
  )
}
